import { apiGet } from '../../api'

export const delete_learner = _id => {
  return apiGet({
    endpoint: `user/delete_user?user_id=${_id}`
  })
}
